export class PaginationData<T> {
  public limit: number;
  public offset: number;
  public total: number;
  public result?: {
    list?: Array<T>;
    total?: number;
  }

  constructor(limit = 50) {
    this.limit = limit;
    this.offset = 0;
    this.total = 0;
  }

  public savePaginationData(res: PaginationData<T> | any): void {
    if (res) {
      this.total = res.result.total;
    }
  }

  public setPage(page) {
    this.offset = page;
  }
}
